import React, { FC, PropsWithChildren } from 'react';

import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import { BaseStyle, CoreUtils, IdEnums, ShortCodeEnums } from '@nhl/nhl-breakaway-ui';

import { StateType } from '~/redux/types';
import PageWrapper from '~/views/components/pageWrapper/PageWrapper';
import SeriesPicker from '~/widgets/seriesPicker/SeriesPicker';

import Scoreboard from '../../components/scoreboard/Scoreboard';
import TabBar from '../../components/tabBar/TabBar';
import { SeriesPickerWrapper } from '../../styles';

const GameCenterLayout: FC<PropsWithChildren> = ({ children }) => {
    const intl = useIntl();
    const game = useSelector((state: StateType) => state.gameCenter);

    const playoffCarousel =
        game.gameType === IdEnums.GameType.playoffs ? (
            <SeriesPickerWrapper>
                <SeriesPicker
                    season={game.season.toString()}
                    language={intl.locale as ShortCodeEnums.Language}
                    baseCarouselProps={{ shouldExpandBelowMediumScreens: false }}
                />
            </SeriesPickerWrapper>
        ) : null;

    return (
        <PageWrapper defaultPageLayout theme={BaseStyle.LightTheme} pageWrapperHeader={playoffCarousel}>
            {game?.gameState !== undefined && <Scoreboard game={game} />}

            {game.gameState && !CoreUtils.isPregame(game.gameState) && <TabBar game={game} />}

            {children}
        </PageWrapper>
    );
};

export default GameCenterLayout;
